export default class UpdateWizardDto {
	readonly id!: string;
	readonly State!: string;

	constructor(data: { id: string; State: string }) {
		Object.assign(this, data);
	}
}
